import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPPolandInvoiceData } from "@/src/types/admissionOffice";

const AOPPolandInvoiceLayout = () => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPPolandInvoiceData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "01",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    coursePrefix: "",
    invoiceBody: [],
  });

  const [bodyForPrev, setBodyForPrev] = useState<AOPPolandInvoiceData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "01",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    coursePrefix: "",
    invoiceBody: [],
  });

  return (
    <>
      <div className="container admission-office-page">
        <AOPConfig dataForGeneration={dataForGeneration} setDataForGeneration={setDataForGeneration} setBodyForPrev={setBodyForPrev} />
        <AOPPrev bodyForPrev={bodyForPrev} />
      </div>
    </>
  );
};

export default AOPPolandInvoiceLayout;
